import styled from "@emotion/styled";
import { TOP_LAYER } from "constants/z-index";
import Constants from "segments/desktop/header/layouts/components/basic-header/constants";
import { FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH, MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH, MAX_DESKTOP_GRID_WIDTH } from "constants/vp-sizes";
export const CARDS_MARGIN = "24px";
const HEADER_CONTENT_HORIZONTAL_PADDING = `${Constants.HEADER_CONTENT_HORIZONTAL_PADDING}px`;
const FULL_SCREEN_LEFT_PADDING = "24px";
const ARROW_WIDTH = "23px";
const ARROW_MARGIN = "16px";
const DEFAULT_CARD_BORDER_RADIUS = "8px";
const DEFAULT_CARD_IMAGE_BORDER_RADIUS = "0, 0, 8px, 8px";
export const StyledSlidingCardGridBaseComponent = styled.div`
  max-width: ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px;
  margin: auto;
  display: flex;
  flex-direction: column;

  padding: ${({ desktopVerticalPadding, desktopHorizontalPadding })=>`${desktopVerticalPadding || "0"} ${desktopHorizontalPadding ? `${desktopHorizontalPadding} !important` : "0"}`};

  @media (max-width: ${MAX_DESKTOP_GRID_WIDTH}px) {
    padding: ${({ desktopVerticalPadding, desktopHorizontalPaddingSmallScreens })=>`${desktopVerticalPadding || "0"} ${desktopHorizontalPaddingSmallScreens ? `${desktopHorizontalPaddingSmallScreens} !important` : "0"}`};
  }

  &.with-title {
    .carousel .slick-slider .slick-list .slick-track {
      padding: 0;
    }
  }

  &.full-carousel-width {
    max-width: ${FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px;
    padding-left: calc(
      max(min(100vw, ${FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px) - ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px, 0px) / 2 +
      ${HEADER_CONTENT_HORIZONTAL_PADDING}
    );
  }

  &.full-screen {
    max-width: ${FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px;
    padding-right: 0;
    padding-left: 24px;

    .carousel-arrow-wrapper {
      &.next {
        left: calc(50% - ${FULL_SCREEN_LEFT_PADDING});
      }

      &.prev {
        left: calc(50% - ${FULL_SCREEN_LEFT_PADDING} - ${ARROW_WIDTH});
      }
    }
  }

  &.infinite-mode {
    .carousel .slick-slider .slick-list .slick-track {
      justify-content: flex-end;
    }
  }

  &.edge-arrows {
    position: relative;
    .carousel-arrows-edge-group {
      position: absolute;
      right: 32px;
      top: ${({ arrowsTopOffset })=>arrowsTopOffset || 0};
      gap: 16px;
      display: flex;
      flex-direction: row;
      z-index: 2;
      background: transparent;
      border: none;
      box-shadow: none;
      .carousel-arrow-wrapper.next,
      .carousel-arrow-wrapper.prev {
        position: static;
        width: 62px;
        height: 62px;
        top: auto;
        left: auto;
        right: auto;
        transform: none;
        box-shadow: none;
        background: transparent;
        border: none;
      }
    }
  }

  .carousel {
    .slick-slider {
      .slick-list {
        .slick-track {
          display: flex;
          padding-bottom: 80px;
          padding-top: 0;

          .slick-slide {
            height: auto;

            > div:first-child {
              height: 100%;
            }
          }

          .carousel-item {
            height: 100%;

            .card-grid-link {
              .grid-paragraph-with-image {
                cursor: grab;
                border-radius: ${({ cardBorderRadius })=>cardBorderRadius || DEFAULT_CARD_BORDER_RADIUS};
                margin-right: ${CARDS_MARGIN};
                min-height: 100%;
                width: 100%;

                .grid-paragraph-wrapper {
                  display: flex;
                  width: 100%;

                  .full-paragraph {
                    .button-wrapper {
                      min-height: 56px;
                      margin-top: 0;

                      .button {
                        display: flex;
                        align-items: flex-end;
                      }
                    }
                  }
                }

                .grid-image-wrapper {
                  max-width: ${({ cardImageSize })=>cardImageSize};
                  min-width: ${({ cardImageSize })=>cardImageSize};

                  img {
                    border-radius: ${({ cardImageRadius })=>cardImageRadius || DEFAULT_CARD_IMAGE_BORDER_RADIUS};
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  &.disable-hover-effect {
    cursor: initial;

    .carousel {
      .slick-slider {
        .slick-list {
          .slick-track {
            .slick-slide:last-child {
              .grid-paragraph-with-image {
                margin-right: 0;
              }
            }

            .carousel-item {
              .card-grid-link {
                .grid-paragraph-with-image {
                  cursor: initial;
                }
              }
            }
          }
        }
      }
    }
  }

  .carousel .carousel-arrow-wrapper {
    top: auto;
    position: absolute;
    bottom: 0;
    z-index: ${TOP_LAYER};
    height: fit-content;
    width: fit-content;

    &.next {
      left: 50%;
      margin-left: ${ARROW_MARGIN};

      &::before {
        content: none;
      }
    }

    &.prev {
      left: calc(50% - ${ARROW_WIDTH});
      margin-left: -${ARROW_MARGIN};

      &::before {
        content: none;
      }
    }
  }

  .carousel-title-component .core-title-container .core-title {
    font-size: 6rem;
    font-weight: 200;
    line-height: 1.1;
  }

  @media (max-width: ${MAX_DESKTOP_GRID_WIDTH}px) {
    .carousel-title-component .core-title-container .core-title {
      font-size: 5rem;
    }
  }
`;
